/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EViewReplayType {
  Vehicle,
  Asset
}
